<template>
  <div type="outlined" class="flex flex-col gap-0.5">
    <div
      class="bg-surface-container rounded-t-large rounded-b-extra-small flex min-h-13 w-full flex-row items-center justify-between gap-2 overflow-hidden pr-1.5 pl-4"
    >
      <h3 class="text-title-medium shrink overflow-hidden text-ellipsis whitespace-nowrap">
        {{ title }}
      </h3>
      <BaseIconButton
        v-tooltip="'Anpassen'"
        icon="edit"
        size="S"
        color="tonalPrimary"
        @click="openDialog"
      />
    </div>
    <div
      v-if="selectedQuestions.length == 0"
      class="rounded-t-extra-small rounded-b-large bg-surface-container flex w-full items-center justify-center p-4"
    >
      <BaseIconButton
        color="tonalPrimary"
        icon="add"
        size="M"
        width="wide"
        class="mx-auto"
        @click="openDialog"
      />
    </div>
    <div class="flex grow flex-col">
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="question in selectedQuestions"
          :key="question.question.id"
          class="rounded-extra-small last:rounded-b-large bg-surface-container flex flex-col p-4"
        >
          <h4 class="text-body-large mb-2">{{ question.question.content }}</h4>
          <PerspectiveValueBarNew
            :values="perspectiveBarEntries(question)"
            :all-perspectives="topicPerspectives"
            :scale="scale"
            :disable-animation="true"
          />
        </li>
      </ul>
    </div>
    <SelectQuestionDialog
      :is-open="isOpen"
      :all-questions="allQuestions"
      :topic-perspectives="topicPerspectives"
      :initial-question-ids="selectedQuestionIds"
      :title="title"
      :scale="scale"
      @close="closeDialog"
      @questions-selected="selectQuestions"
    />
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { useDialog } from '../../../core/components/base/dialog/use-dialog'
  import SelectQuestionDialog from './SelectQuestionDialog.vue'
  import BaseIconButton from '../../../core/components/base/button/icon-button/BaseIconButton.vue'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  import type { Perspective } from '@/core/models/perspective'
  import { toValueBarPerspectives } from '@/core/models/perspective-analysis'
  import PerspectiveValueBarNew from '@/core/components/analytics/question-list/PerspectiveValueBarNew.vue'
  interface Props {
    title: string
    allQuestions: ReadonlyArray<QuestionAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
    scale: ReadonlyArray<{ value: number; label: string }>
  }
  const props = defineProps<Props>()

  const { isOpen, openDialog, closeDialog } = useDialog()

  const selectedQuestionIds = defineModel<string[]>({ required: true })

  const selectedQuestions = computed(() => {
    return props.allQuestions.filter((question) =>
      selectedQuestionIds.value.includes(question.question.id),
    )
  })

  const selectQuestions = (questionIds: string[]) => {
    selectedQuestionIds.value = questionIds
  }

  const perspectiveBarEntries = (question: QuestionAnalysis) =>
    toValueBarPerspectives(question.perspectives, props.topicPerspectives)
</script>
